<template>
    <div class="help">
        <div class="container">
            <h1 class="title">Release Notes</h1>

            <div class="overview">
            The PreBinds calculates based on the following data
            </div>

            <div class="table-wrapper">
                <table>
                    <tr>
                        <th>ChEMBL</th>
                        <td>ChEMBL_28</td>
                    </tr>
                    <tr>
                        <th>PFam</th>
                        <td>TBD</td>
                    </tr>
                    <tr>
                        <th>PDB</th>
                        <td>TBD</td>
                    </tr>
                </table>
            </div>

        </div>
    </div>


</template>

<script>

export default {
    name: 'Help',
    components: {
    },
    data: function() {
        return {
        }
    },
    mounted() {
    },
    methods: {
    }
}
</script>

<style scoped>
.container {
    width: 80%;
    margin-left: 10%;
    margin-right: 10%;
    font-size: 18px;
}

.block {
    padding: 30px;
    border: solid 1px;
    margin-top: 100px;
    margin-bottom: 100px;
}

.description {
    text-align: left;
}

.capture {
    text-aling:center;
}

.capture img {
    margin-top: 30px;
    margin-bottom: 30px;
    margin-left: 20%;
    margin-right: auto;
    width: 60%;
}

.table-wrapper {
}

table {
    width: 480px;
    border: solid 1px;
    margin-left: auto;
    margin-right: auto;
}

table th {
    width: 120px;
    border: solid 1px;
}

table td {
    border: solid 1px;
}
</style>